export const load = () => ({
	title: 'Privacy Window Coverings For Your Home',
	h1: 'Instant Privacy With Window Inserts',
	description:
		'Add privacy from prying eyes to any window with opaque window inserts.',
	showTitle: true,
});
